// check whether user's email is verified, will restrict user carelessly visiting otp and password pages
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { string } from "yup";
import { useAuth } from "../Store/AuthContext";

const RouteRestrict = ({ children }) => {
  const authState = useAuth();
  const location = useLocation();
  const state = location.state;
  const path = location.pathname;

  return (path.includes("otp") && state?.username) || //email verified for email
    (path.includes("password") && state?.username && state?.otpVerified) || (path.includes("forgot-password") && authState?.state.user) || (path.includes("reset-password") && location?.search)
    ? ( //email verified and otp verified
    <Outlet />
  ) : (
    <Navigate to={"/Signin/enter-username"} />
  );
};

export default RouteRestrict;